import { Features, isEnabled, isEnabledForValue } from '../../models/features'
import { ModuleFeatures } from '../../hooks/useModuleMenu'
import { modules } from '../../../modules'

export const isPaymentManagementModuleEnabled = representativeId => {
  return (
    isEnabledForValue(
      Features.ACTIVATED_REPRESENTATIVES_FOR_PAYMENT_MANAGEMENT_MODULE,
      representativeId,
    ) || isEnabled(ModuleFeatures[modules.paymentManagementApp.name])
  )
}
